export default __webpack_public_path__ + "static/navbar-logo-4967f61113cd62ddc3cf5a280fab1086.svg";